import {isNil, isString} from 'lodash';

export default function baseListFormatterParams(params) {
  const {value} = params;
  let ownValue = null;
  if (!isNil(value)) {
    if (value.value) {
      ownValue = JSON.parse(value.value);
    } else if (isString(value)) {
      ownValue = JSON.parse(value);
    }
  }

  return {...params, ownValue};
}
